/** TG + 4 digits, or the known_client flag: pickup without an ID document. */
export function isKnownClientTransferId(transferId) {
  const raw = String(transferId || "").toUpperCase().replace(/\s/g, "").replace(/^#/, "");
  return /^TG\d{4}$/.test(raw);
}

export function transferSkipsId(tr) {
  if (!tr) return false;
  if (tr.known_client) return true;
  return isKnownClientTransferId(tr.transfer_id);
}

export const KNOWN_RECEIPT_FOOTER =
  "Moun sa a nou konnen. Li dwe konnen nimewo transfè a pou li rekipere kòb la nan biwo a. Pa bezwen pyès idantite.";
